(() => {

    function translateSearchaniseAvailability() {

        if (Shopify.locale !== "en") return;

        document.querySelectorAll(".snize-filter-checkbox + .needsclick").forEach(el => {

            const textNode = [...el.childNodes].find(node => node.nodeType === Node.TEXT_NODE);

            if (!textNode) return;

            const value = textNode.textContent.trim();

            switch (value) {

                case "En Stock":
                    textNode.textContent = "In Stock ";
                    break;

                case "Épuisé":
                    textNode.textContent = "Out of Stock ";
                    break;

            }

        });

    }

    // Première tentative
    translateSearchaniseAvailability();

    // Puis à chaque changement du DOM Searchanise
    new MutationObserver(() => {
        translateSearchaniseAvailability();
    }).observe(document.body, {
        childList: true,
        subtree: true
    });

})();